import { Component, Inject, inject, OnInit, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { AppResource } from 'src/app/app.resource';
import { CombinedState, CombinedStore } from 'src/app/core/combined.store';
import { Resource } from 'src/app/resources/resource';
import { Store } from 'src/app/shared/enum/store.enum';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  standalone: true,
  providers: [CombinedStore],
})
export abstract class BaseComponent implements OnInit {
  public resource!: Resource;
  public store = inject(CombinedStore);
  public form!: FormGroup;
  public submitted = false;
  isLoading = signal<boolean>(false);

  constructor(
    protected resources: AppResource,
    protected navigationService?: NavigationService,
    @Inject('storeName') public storeName?: string,
  ) {
    this.resource = resources['resource'];
    this.storeName = storeName ?? Store.Declaration;
    this.form = new FormGroup({});
    if (this.navigationService) this.navigationService.formSubmitted = false;
    this.scrollToTop();
  }

  ngOnInit() {}

  updateFormWithStore() {
    const controlValueStore = (this.store.select() as CombinedState)[
      this.storeName as keyof CombinedState
    ];

    if (this.form !== undefined && typeof controlValueStore === 'object') {
      if (controlValueStore) {
        updateFormGroupValues(this.form, controlValueStore);
      }
      this.navigationService?.updateStepValidity(this.form.valid);
    }
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  hasError(control: AbstractControl<any, any> | null): boolean {
    return (
      !!control?.invalid &&
      (control?.dirty ||
        control?.touched ||
        this.navigationService?.formSubmitted!)
    );
  }
}

function updateFormGroupValues(
  formGroup: FormGroup,
  controlValueStore: { [key: string]: any },
) {
  Object.keys(formGroup.controls).forEach((controlName) => {
    const control = formGroup.controls[controlName];
    const controlValue = controlValueStore[controlName];

    const controlEventEmit = ['account_owner'];

    if (control instanceof FormGroup) {
      // Si le contrôle est un FormGroup, appeler récursivement la fonction
      updateFormGroupValues(control, controlValue || {});
    } else if (controlValue !== undefined) {
      // Sinon, c'est un FormControl, donc on peut définir la valeur
      if (controlEventEmit.includes(controlName)) {
        control.setValue(controlValue, { emitEvent: false });
      } else {
        control.setValue(controlValue);
      }
    }
  });
}
